import { Component, ElementRef, HostListener, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'planone-expandable-text',
  templateUrl: './expandable-text.component.html',
  styleUrls: ['./expandable-text.component.scss'],
})
export class ExpandableTextComponent implements OnInit, OnChanges {
  @Input() text: string | SafeHtml | undefined;
  @Input() backgroundColor: string | undefined;

  @ViewChild('textElement') textElement?: ElementRef;
  @ViewChild('referenceElement') referenceElement?: ElementRef;

  maxHeight = 0;
  textOverflowing = false;
  textExpanded = false;

  private identifyTextOverflow(): void {
    if (this.textElement && this.referenceElement) {
      this.textOverflowing =
        this.referenceElement.nativeElement.offsetHeight > this.textElement.nativeElement.offsetHeight;
      this.maxHeight = this.referenceElement.nativeElement.offsetHeight;
    }
  }

  ngOnInit(): void {
    setTimeout(() => this.identifyTextOverflow());
  }

  ngOnChanges(): void {
    this.identifyTextOverflow();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.identifyTextOverflow();
  }

  toggle(): void {
    this.textExpanded = !this.textExpanded;
  }
}
